import { render } from "./Bunkers.vue?vue&type=template&id=537dc0c1"
import script from "./Bunkers.vue?vue&type=script&lang=js"
export * from "./Bunkers.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__